import HeaderSearch from "./HeaderSearch";
import LogoutDropdownItem from "./Logout";
import { useUser } from "../context/UserContext";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../Api";
import { Modal, Button } from "react-bootstrap";
import {
  formatCost,
  formatDateWithTime,
  formatDateForTable,
} from "../helpers/Helpers";

function Navbar({ hidden = false }) {
  const { fullName, role, username } = useUser();
  const [notifications, setNotifications] = useState([]);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState([]);
  const requestNotifications = notifications.filter((n) =>
    n.message?.toLowerCase().includes("pr"),
  );

  const dueNotifications = notifications.filter(
    (n) =>
      n.message?.toLowerCase().includes("pending") ||
      n.message?.toLowerCase().includes("due"),
  );

  const clearSelected = async () => {
    try {
      await api.post("/notifications/clear-selected", {
        ids: selectedIds,
      });

      setNotifications((prev) =>
        prev.filter((n) => !selectedIds.includes(n.id)),
      );

      setSelectedIds([]);
    } catch (err) {
      console.error(err);
    }
  };

  const clearAll = async () => {
    try {
      await api.post("/notifications/clear-all");

      setNotifications([]);
      setSelectedIds([]);
    } catch (err) {
      console.error(err);
    }
  };


  const handleRequestNotificationClick = async (notificationId) => {
    try {
      await api.post("/notifications/clear-selected", {
        ids: [notificationId],
      });

      setNotifications((prev) =>
        prev.filter((n) => n.id !== notificationId)
      );

      navigate("/purchase-request/lists");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!username) return;

    let mounted = true;

    const fetchNotifications = async () => {
      try {
        const res = await api.get("/notifications");

        if (mounted) {
          setNotifications(Array.isArray(res.data) ? res.data : []);
        }
      } catch (err) {
        if (err.response?.status !== 401 && err.response?.status !== 403) {
          console.error("Notification Error:", err);
        }

        if (mounted) setNotifications([]);
      }
    };

    fetchNotifications();

    return () => {
      mounted = false;
    };
  }, [username]);

  const unreadAllCount = notifications.filter((n) => !n.is_read).length;

  const unreadRequestCount = requestNotifications.filter(
    (n) => !n.is_read,
  ).length;

  const unreadDueCount = dueNotifications.filter((n) => !n.is_read).length;

  const handleHamburgerClick = () => {
    const e = document.documentElement.clientWidth;
    const hamburgerIcon = document.querySelector(".hamburger-icon");
    if (hamburgerIcon) {
      hamburgerIcon.classList.toggle("open");
    }

    const layout = document.documentElement.getAttribute("data-layout") || "vertical";

    if (layout === "horizontal") {
      document.body.classList.toggle("menu");
    } else if (layout === "vertical") {
      if (e <= 1025 && e > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        const size = document.documentElement.getAttribute("data-sidebar-size");
        document.documentElement.setAttribute("data-sidebar-size", size === "sm" ? "" : "sm");
      } else if (e > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        const size = document.documentElement.getAttribute("data-sidebar-size");
        document.documentElement.setAttribute("data-sidebar-size", size === "sm" ? "lg" : "sm");
      } else if (e <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    } else if (layout === "semibox") {
      if (e > 767) {
        const visibility = document.documentElement.getAttribute("data-sidebar-visibility");
        if (visibility === "show") {
          const size = document.documentElement.getAttribute("data-sidebar-size");
          document.documentElement.setAttribute("data-sidebar-size", size === "sm" ? "lg" : "sm");
        } else {
          const showBtn = document.getElementById("sidebar-visibility-show");
          if (showBtn) showBtn.click();
          const size = document.documentElement.getAttribute("data-sidebar-size");
          document.documentElement.setAttribute("data-sidebar-size", size);
        }
      } else if (e <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    } else if (layout === "twocolumn") {
      document.body.classList.toggle("twocolumn-panel");
    }
  };

  return (
    <header id="page-topbar" style={{ display: hidden ? "none" : "block" }}>
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <Link to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src="../../assets/images/cibill.png"
                    alt=""
                    height="22"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="../../assets/images/cibill.png"
                    alt=""
                    height="45"
                  />
                </span>
              </Link>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src="../../assets/images/cibill.png"
                    alt=""
                    height="22"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="../../assets/images/cibill.png"
                    alt=""
                    height="45"
                  />
                </span>
              </Link>
            </div>
            <button
              onClick={handleHamburgerClick}
              type="button"
              className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger material-shadow-none"
              id="topnav-hamburger-icon"
            >
              <i className="ri-menu-line"></i>
            </button>

            <form className="app-search d-none d-md-block">
              <div className="position-relative">
                <HeaderSearch />
              </div>
            </form>
          </div>

          <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure?</Modal.Body>
            <Modal.Footer>
              <Button onClick={() => setShow(false)}>Close</Button>
            </Modal.Footer>
          </Modal>

          <div className="d-flex align-items-center">
            <div className="dropdown d-md-none topbar-head-dropdown header-item">
              <button
                type="button"
                className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-search fs-22"></i>
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <button className="btn btn-primary" type="submit">
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="dropdown topbar-head-dropdown ms-1 header-item">
              <button
                type="button"
                className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-category-alt fs-22"></i>
              </button>

              <div className="dropdown-menu dropdown-menu-lg p-3 dropdown-menu-end">
                <h6 className="fw-semibold text-uppercase mb-3">Shortcuts</h6>

                <div className="row g-2">
                  <div className="col-6">
                    <Link
                      to="/projects/lists"
                      className="shortcut-card d-flex flex-column align-items-center justify-content-center text-center p-3 rounded shadow-sm bg-light hover-scale"
                    >
                      <i className="ri-folder-line fs-32 mb-2 text-primary"></i>
                      <span className="fw-semibold">Projects</span>
                      <kbd className="mt-1">Alt + P</kbd>
                    </Link>
                  </div>

                  <div className="col-6">
                    <Link
                      to="/ledger/lists"
                      className="shortcut-card d-flex flex-column align-items-center justify-content-center text-center p-3 rounded shadow-sm bg-light hover-scale"
                    >
                      <i className="ri-file-list-3-line fs-32 mb-2 text-success"></i>
                      <span className="fw-semibold">Ledger</span>
                      <kbd className="mt-1">Alt + L</kbd>
                    </Link>
                  </div>

                  <div className="col-6">
                    <Link
                      to="/customers/lists"
                      className="shortcut-card d-flex flex-column align-items-center justify-content-center text-center p-3 rounded shadow-sm bg-light hover-scale"
                    >
                      <i className="ri-user-line fs-32 mb-2 text-warning"></i>
                      <span className="fw-semibold">Customers</span>
                      <kbd className="mt-1">Alt + C</kbd>
                    </Link>
                  </div>

                  <div className="col-6">
                    <Link
                      to="/employee/lists"
                      className="shortcut-card d-flex flex-column align-items-center justify-content-center text-center p-3 rounded shadow-sm bg-light hover-scale"
                    >
                      <i className="ri-team-line fs-32 mb-2 text-info"></i>
                      <span className="fw-semibold">Employees</span>
                      <kbd className="mt-1">Alt + E</kbd>
                    </Link>
                  </div>

                  <div className="col-6">
                    <Link
                      to="/cash-book/lists"
                      className="shortcut-card d-flex flex-column align-items-center justify-content-center text-center p-3 rounded shadow-sm bg-light hover-scale"
                    >
                      <i className="ri-bank-line fs-32 mb-2 text-danger"></i>
                      <span className="fw-semibold">Accounts</span>
                      <kbd className="mt-1">Alt + A</kbd>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="ms-1 header-item d-none d-sm-flex">
              <button
                type="button"
                className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen fs-22"></i>
              </button>
            </div>

            <div
              className="dropdown topbar-head-dropdown ms-1 header-item"
              id="notificationDropdown"
            >
              <button
                type="button"
                className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                id="page-header-notifications-dropdown"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-bell fs-22"></i>
                <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                  {unreadAllCount}
                  <span className="visually-hidden">unread messages</span>
                </span>
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-notifications-dropdown"
              >
                <div className="dropdown-head bg-primary bg-pattern rounded-top">
                  <div className="p-3">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="m-0 fs-16 fw-semibold text-white">
                          {" "}
                          Notifications{" "}
                        </h6>
                      </div>
                      <div className="col-auto dropdown-tabs">
                        <span className="badge bg-light text-body fs-13">
                          {" "}
                          {unreadAllCount} New
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="px-2 pt-2">
                    <ul
                      className="nav nav-tabs dropdown-tabs nav-tabs-custom"
                      data-dropdown-tabs="true"
                      id="notificationItemsTab"
                      role="tablist"
                    >
                      <li className="nav-item waves-effect waves-light">
                        <a
                          className="nav-link active d-flex align-items-center"
                          data-bs-toggle="tab"
                          href="#all-noti-tab"
                          id="all-noti-tab-link"
                          role="tab"
                          aria-selected="true"
                        >
                          <span>All</span>
                          {unreadAllCount > 0 && (
                            <span className="badge bg-danger rounded-pill ms-2">
                              {unreadAllCount}
                            </span>
                          )}
                        </a>
                      </li>
                      <li className="nav-item waves-effect waves-light">
                        <a
                          className="nav-link d-flex align-items-center"
                          data-bs-toggle="tab"
                          href="#requests-tab"
                          id="requests-tab-link"
                          role="tab"
                          aria-selected="false"
                        >
                          <span>Requests</span>
                          {unreadRequestCount > 0 && (
                            <span className="badge bg-danger rounded-pill ms-2">
                              {unreadRequestCount}
                            </span>
                          )}
                        </a>
                      </li>
                      <li className="nav-item waves-effect waves-light">
                        <a
                          className="nav-link d-flex align-items-center"
                          data-bs-toggle="tab"
                          id="dues-tab-link"
                          href="#dues-tab"
                          role="tab"
                          aria-selected="false"
                        >
                          <span>Dues</span>
                          {unreadDueCount > 0 && (
                            <span className="badge bg-danger rounded-pill ms-2">
                              {unreadDueCount}
                            </span>
                          )}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="tab-content position-relative"
                  id="notificationItemsTabContent"
                >
                  <div
                    className="tab-pane fade show active py-2 ps-2"
                    id="all-noti-tab"
                    role="tabpanel"
                    aria-labelledby="all-noti-tab-link"
                  >
                    <div
                      className="pe-2"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {notifications.length === 0 ? (
                        <p className="text-center p-3">No Notifications</p>
                      ) : (
                        notifications.map((noti) => (
                          <div
                            key={noti.id}
                            onClick={() => handleRequestNotificationClick(noti.id)}
                            className="text-reset notification-item d-block dropdown-item position-relative"
                          >
                            <div className="d-flex">
                              <div className="avatar-xs me-3 flex-shrink-0">
                                <span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                                  <i className="bx bx-bell"></i>
                                </span>
                              </div>

                              <div className="flex-grow-1">
                                <h6 className="mt-0 mb-2 fs-13 lh-base">
                                  {noti.message ||
                                    noti.text ||
                                    noti.notification_message ||
                                    "No message"}
                                </h6>

                                <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                  <i className="mdi mdi-clock-outline"></i>{" "}
                                  {noti.created_at
                                    ? formatDateWithTime(noti.created_at)
                                    : "Just now"}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                    <div className="d-flex justify-content-center gap-2 p-2">
                      <button
                        className="btn btn-md btn-danger"
                        onClick={clearAll}
                      >
                        Clear All
                      </button>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade py-2 ps-2"
                    id="requests-tab"
                    role="tabpanel"
                    aria-labelledby="requests-tab-link"
                  >
                    <div
                      className="pe-2"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {requestNotifications.length === 0 ? (
                        <p className="text-center p-3">No Purchase Requests</p>
                      ) : (
                        requestNotifications.map((noti) => (
                          <div
                            key={noti.id}
                            onClick={() => handleRequestNotificationClick(noti.id)}
                            className="text-reset notification-item d-block dropdown-item position-relative"
                          >
                            <div className="d-flex">
                              <div className="avatar-xs me-3 flex-shrink-0">
                                <span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                                  <i className="bx bx-bell"></i>
                                </span>
                              </div>

                              <div className="flex-grow-1">
                                <h6 className="mt-0 mb-2 fs-13 lh-base">
                                  {noti.message ||
                                    noti.text ||
                                    noti.notification_message ||
                                    "No message"}
                                </h6>

                                <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                  <i className="mdi mdi-clock-outline"></i>{" "}
                                  {noti.created_at
                                    ? formatDateWithTime(noti.created_at)
                                    : "Just now"}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                    <div className="d-flex justify-content-center gap-2 p-2">
                      <button
                        className="btn btn-md btn-danger"
                        onClick={clearAll}
                      >
                        Clear All
                      </button>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade py-2 ps-2"
                    id="dues-tab"
                    role="tabpanel"
                    aria-labelledby="dues-tab-link"
                  >
                    <div
                      className="pe-2"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {dueNotifications.length === 0 ? (
                        <p className="text-center p-3">No Due Payments</p>
                      ) : (
                        dueNotifications.map((noti) => (
                          <div
                            key={noti.id}
                            onClick={() => {
                              setSelectedIds((prev) =>
                                prev.includes(noti.id)
                                  ? prev.filter((id) => id !== noti.id)
                                  : [...prev, noti.id],
                              );
                            }}
                            className={`text-reset notification-item d-block dropdown-item position-relative ${selectedIds.includes(noti.id) ? "bg-light" : ""
                              }`}
                          >
                            <div className="d-flex">
                              <div className="avatar-xs me-3 flex-shrink-0">
                                <span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                                  <i className="bx bx-bell"></i>
                                </span>
                              </div>

                              <div className="flex-grow-1">
                                <h6 className="mt-0 mb-2 fs-13 lh-base">
                                  {noti.message || "No message"}
                                </h6>

                                <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                  <i className="mdi mdi-clock-outline"></i>{" "}
                                  {noti.created_at
                                    ? formatDateWithTime(noti.created_at)
                                    : "Just now"}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                    <div className="d-flex justify-content-center gap-2 p-2">
                      <button
                        className="btn btn-md btn-danger"
                        onClick={clearAll}
                      >
                        Clear All
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="dropdown ms-sm-3 header-item topbar-user">
              <button
                type="button"
                className="btn material-shadow-none"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center">
                  <img
                    className="rounded-circle header-profile-user"
                    src="../../assets/images/users/user-tesdef.jpg"
                    alt="Header Avatar"
                  />
                  <span className="text-start ms-xl-2">
                    <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                      {fullName || "Admin"}
                    </span>
                    <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                      {role || "Founder"}
                    </span>
                  </span>
                </span>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <Link className="dropdown-item" to="/profile">
                  <i className="mdi mdi-account-circle fs-16 text-muted align-middle me-1"></i>
                  <span className="align-middle">Profile</span>
                </Link>

                <Link className="dropdown-item" to="/activity-log">
                  <i className="mdi mdi-calendar-check fs-16 text-muted align-middle me-1"></i>
                  <span className="align-middle">Activity Log</span>
                </Link>

                <Link className="dropdown-item" to="/deleted-items">
                  <i className="mdi mdi-delete fs-16 text-muted align-middle me-1"></i>
                  <span className="align-middle">Deleted Items</span>
                </Link>

                <div className="dropdown-divider"></div>

                <LogoutDropdownItem />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
